import { SpringFiltrationPagination } from '../../shared/interfaces/SpringFiltration';
import { SpringPagination } from '../../shared/interfaces/SpringPagination';
import { apiService } from '../../shared/services/apiService';
import { Note, UsersListOption, NoteRequest } from '../interfaces/note';

type GetUsersListResponse = {
  names: UsersListOption[];
};

type GetNotesResponse = SpringPagination<Note[]>;

export const notesService = {
  async getAllNotes(requestedPage: SpringFiltrationPagination) {
    const response = await apiService.post<GetNotesResponse>(
      'api/coach/notes/all',
      requestedPage,
    );

    return response.data;
  },

  async getNotesByCustomer(
    customerId: string,
    requestedPage: SpringFiltrationPagination,
  ) {
    const response = await apiService.post<GetNotesResponse>(
      `api/coach/notes/users/${customerId}`,
      requestedPage,
    );

    return response.data;
  },

  async createNote(note: NoteRequest) {
    const response = await apiService.post<Note>('api/coach/notes', note, {
      isRunGlobalSpinner: false,
    });

    return response.data;
  },

  async updateNote(noteId: number, note: NoteRequest) {
    const response = await apiService.put<Note>(`api/coach/notes/${noteId}`, note, {
      isRunGlobalSpinner: false,
    });

    return response.data;
  },

  async deleteNote(noteId: number) {
    const response = await apiService.delete<undefined>(`api/coach/notes/${noteId}`);

    return response;
  },

  async getUsersList() {
    const response = await apiService.get<GetUsersListResponse>('api/coach/user-names');

    return response.data;
  },
};
